import { FreeDataWrapper, FreeDataCriteria, FreeDataScenario, DataMetrics } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { FreedataDataload } from '../../../vo/core/freedata.dataload';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';

/**
 * appels pour synchro des FDs remote
 */
export class FreedataCountCmd extends WizCommand<DataMetrics> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  public dataLoad: FreedataDataload; // le pool de chargement
 
  /** retourne un wrapper pre-alimenté pour un appel complet du FD (avec values) */
  public  freedataWrapper(): FreeDataWrapper {
    const wrapper: FreeDataWrapper = new FreeDataWrapper();
    wrapper.criteria = new FreeDataCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new FreeDataScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.scenario.manageArgs = true;
    wrapper.scenario.manageLevels = true;
    wrapper.scenario.manageValues = false;
    return wrapper;
  }

  /** 
   * compte les FD / FDVs et EMs sur le périmètre
   * 
   * @param dataload le pool de chargement
   * @param freedataCode cible, pour refresh avant commit
   * @param callback de retour
   * @returns la commande préparée
   */
  public count(dataload: FreedataDataload, freedataCode?: string, callback?: Function): FreedataCountCmd {
    this.dataLoad = dataload;

    const wrapper: FreeDataWrapper = this.freedataWrapper();
    wrapper.criteria.revisionNumber = this.dataLoad.revisionNumber; // par numRev
    
    if(freedataCode) { // recherche ciblée pour 1 Freedata
      wrapper.criteria.freeDataCodeList = [freedataCode];
    }

    this.configureRemote(ExternalAPI.FREEDATA_COUNT_API, wrapper, callback);
    return this;
  }


  public wizResult(): void {
    super.wizResult();
    if (this.result) {
      let metrics: DataMetrics = this.result;
      this.dataLoad.state = FreedataDataload.LOADING;
      this.dataLoad.nbFds = metrics.nbFreedatas;
      this.dataLoad.nbFdvs = metrics.nbFreedataValues;
      this.dataLoad.nbDeleteds = metrics.nbDeleted;
      this.dataLoad.remoteRevisionNumber = metrics.numRev;
    } else {
      console.log('freedataCmd no result');
    }
  }
}
